import type { ComponentType } from "react"
import type { NodeKey } from "lexical"

export type MergeTagComponentProps = {
  tagId: string
  tagLabel: string
  nodeKey: NodeKey
}

let mergeTagComponent: ComponentType<MergeTagComponentProps> | null = null

export const registerMergeTagComponent = (
  component: ComponentType<MergeTagComponentProps>,
): void => {
  mergeTagComponent = component
}

export const getMergeTagComponent = (): ComponentType<MergeTagComponentProps> => {
  if (!mergeTagComponent) {
    throw new Error("MergeTagComponent is not registered")
  }

  return mergeTagComponent
}
